import s from '../collegesItem.module.css'
import {useState} from "react";
import {Button} from "antd";
import {useAddAlert} from "@/hooks/useAddAlert";
import {usersAPI} from "@api"

import { InputFile, InputNew } from "@UI/InputNew";
import { useInputNew } from "@UI/InputNew/useInputNew";

const ModalAddContracts = ({setActive, userId, update}) => {
  const addAlert = useAddAlert();

  const [loading, setLoading] = useState(false);
  
  const [errorsList, setErrorsList] = useState([]);
  const [showErrors, setShowErrors] = useState(false);
  const [file, setFile] = useState("");
  const [name, setName] = useState("");
  const [bindName] = useInputNew({
    name: "file_name",
    value: name,
    onChange: setName,
    onError: setErrorsList,
    placeholder: "Введите название файла",
    validate: showErrors,
    errorText: "Введите название файла",
  });

  const [bindFile] = useInputNew({
    name: "file",
    value: file,
    onChange: setFile,
    placeholder: "Выберите файл",
    onError: setErrorsList,
    validate: showErrors,
  });

  const save = () => {
    setShowErrors(true);
    if (errorsList.valid) {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("name", name);
      formData.append("user_id", userId);

      usersAPI.addContract({ data: formData })
      .then((res) => {
        if (res.data.status === "success") {
            addAlert({ text: 'Договор успешно добавлен'})
            setActive(false)
            update("contracts");
        }
        else {
            addAlert({ title: 'Ошибка', text: 'При загрузке договора ошибка', type: 'error' })
            setActive(false)
        }
      })
      .finally((res)=>{
        setLoading(false);
      })
      
    }
  };

  return <div className="modal_departments">
    <h2 className="modal__title">Добавить договор</h2>
    <div className={s.body}>
          <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Введите название договора</span>
          <InputNew style={{width:'100%'}} className={s.input} {...bindName} />
          <span style={{fontSize:'12px', color:'#000000e0', fontWeight:'400', marginBottom:'-10px'}}>Добавьте файл договора</span>
          <InputFile style={{width:'100%'}} className={s.input} {...bindFile} />
          <Button disabled={loading} onClick={save}>Сохранить</Button>
    </div>
  </div>
}
export default ModalAddContracts;